import { useLocation } from 'react-router-dom';
import { isItemActive } from '../SidebarItem/SidebarItem';

export const hasActiveChild = (currentPathname, children = []) => {
  return children.some((child) =>
    isItemActive(currentPathname, child.path, child.matchPaths)
  );
};

const SidebarGroup = ({ item, isOpen, onToggle }) => {
  const { pathname } = useLocation();
  const childrenActive = hasActiveChild(pathname, item.children);

  const handleClick = (e) => {
    e.preventDefault();
    onToggle();
  };

  const groupClassName = [
    'sidebar-item',
    'sidebar-link',
    'has-sub',
    childrenActive || isOpen ? 'active' : '',
    isOpen ? 'is-open' : ''
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <li className={groupClassName} id={item.id}>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a href="#" onClick={handleClick}>
        {item.icon && <span className={item.icon} />}
        <span>{item.label}</span>
      </a>

      <ul className={`sidebar-sub${isOpen ? ' is-open' : ''}`}>
        {item.children.map((child) => {
          const active = isItemActive(pathname, child.path, child.matchPaths);
          return (
            <li
              key={child.id}
              className={`sidebar-item sidebar-link${active ? ' active' : ''}`}
              id={child.id}>
              <a href={child.path} className={active ? 'curent' : ''}>
                {child.label}
              </a>
            </li>
          );
        })}
      </ul>
    </li>
  );
};

export default SidebarGroup;
